'use strict';

const dayNames = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sabado'];
const monthNames = [
  'Enero', 'Febrero', 'Marzo',
  'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre',
  'Octubre', 'Noviembre', 'Diciembre'
];

const pad2 = val => ('00' + val).slice(-2);

const extractors = {
  D: date => date.getUTCDate(),
  DD: date => pad2(date.getUTCDate()),
  dddd: date => dayNames[date.getUTCDay()],
  MM: date => pad2(date.getUTCMonth() + 1),
  MMMM: date => monthNames[date.getUTCMonth()],
  YYYY: date => date.getUTCFullYear(),
  HH: date => pad2(date.getUTCHours()),
  mm: date => pad2(date.getUTCMinutes()),
  ss: date => pad2(date.getUTCSeconds())
};

const tokens = Object.keys(extractors);
tokens.sort((a, b) => b.length - a.length); // ordenar por largo, de mayor a menor
const regex = new RegExp(tokens.join('|'), 'g');

module.exports = function format(date, template) {
  return template.replace(regex, match => extractors[match](date));
};
